import React from "react";
import "../../styles/hero.css";

const Hero = () => {
  return (
    <section className="pro-hero-wrapper container">
      <div className="pro-hero-card row align-items-center g-0">
        {/* LEFT TEXT SECTION */}
        <div className="col-lg-8 col-md-12 pro-hero-text-col position-relative">
          <h1 className="pro-hero-title">
            Upgrade Your Skills.
            <br />
            Unlock Your Potential.
          </h1>

          <p className="pro-hero-subtitle">
            At Madhi Academy, we provide practical, career-oriented skill
            training designed to make you job-ready. Our courses are crafted for
            students, job seekers, and working professionals who want to boost
            their careers with ERP expertise, computer literacy, and fluent
            English communication.
          </p>

          
        </div>

        {/* RIGHT IMAGE SECTION */}
        <div className="col-lg-4 col-md-12 pro-hero-img-col">
          {/* 1. Background Pattern (z-index: 0) */}
       {/*    <img
            src="https://school.madhiacademy.com/wp-content/uploads/sites/2/2025/09/Asset-05-copy.png"
            alt="Pattern"
            className="pro-hero-pattern"
          />
 */}
          {/* 2. Main Professional Image (z-index: 2) */}
          <img
            src="https://i.pinimg.com/1200x/ea/b5/d8/eab5d815eee9befe72ddf48ed9ab8b9e.jpg"
            alt="Global Professional"
            className="pro-hero-main-img"
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;
